// extracted by mini-css-extract-plugin
export var locationCard = "_gt-0";